<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row >
      <b-col sm="12" >
        <h4 style="text-align: center">3. DATOS CURRICULARES DEL DECLARANTE</h4>
      </b-col>
        <!-- <b-col sm="12" >
        <h6 style="text-align: center">Agregar los últimos tres grados de estudio.</h6>
      </b-col>            -->
      <b-list-group sm="12">
        <b-list-group-item v-for="(estudio, index) in escolaridad" :key="index">
          <b-row style="text-align: center">
          <b-col sm="12" >
           <h5 style="text-align: center">TIPO DE OPERACIÓN </h5>
          </b-col>      
          <b-col sm="4">
           <b-button
              v-if="status !== 'Concluida'"              
              size="sm"
              :variant="estudio.tipoOperacion == 'SIN CAMBIOS'? 'info' : 'outline-info'"
              @click="estudio.tipoOperacion = 'SIN CAMBIOS'"
              >SIN CAMBIOS</b-button>
          </b-col>
          <b-col sm="4">
           <b-button
              v-if="status !== 'Concluida'"
              :variant="estudio.tipoOperacion == 'MODIFICAR'? 'success' : 'outline-success'"
              size="sm"
              @click="estudio.tipoOperacion = 'MODIFICAR'"
              >MODIFICAR</b-button>
          </b-col>
          <b-col sm="4">
           <b-button
              v-if="status !== 'Concluida'"
              variant="outline-danger"
              size="sm"
              @click="eliminarEscolaridad(estudio._id, index)"
              >ELIMINAR</b-button>
          </b-col>          
          </b-row>
          <b-row>
          <b-col md="3">
            <b-form-group label="UBICACIÓN">
              <b-form-select
                :disabled="status == 'Concluida' || estudio.tipoOperacion == 'SIN CAMBIOS'"
                @change="seRealizaronCambios(estudio._id)"
                v-model="estudio.institucionEducativa.ubicacion"
                :options="pais"
                text-field="valor"
                value-field="clave"
                >
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="NIVEL">
              <b-form-select
                :disabled="status == 'Concluida' || estudio.tipoOperacion == 'SIN CAMBIOS'"
                v-model="estudio.nivel.clave"
                :options="nivel"
                text-field="valor"
                value-field="clave"
                @change="seleccionaValor(index), seRealizaronCambios(estudio._id)"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label >INSTITUCIÓN EDUCATIVA</label>
              <b-form-input
                :disabled="status == 'Concluida' || estudio.tipoOperacion == 'SIN CAMBIOS'"
                @change="seRealizaronCambios(estudio._id)"
                v-model="estudio.institucionEducativa.nombre"
                placeholder="NOMBRE DE LA INSTITUCIÓN"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label >CARRERA O ÁREA DE CONOCIMIENTO</label >
              <b-form-input
                :disabled="status == 'Concluida' || estudio.tipoOperacion == 'SIN CAMBIOS'"
                @change="seRealizaronCambios(estudio._id)"
                v-model="estudio.carreraAreaConocimiento"
                placeholder="CARRERA"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="ESTATUS">
              <b-form-select
                :disabled="status == 'Concluida' || estudio.tipoOperacion == 'SIN CAMBIOS'"
                @change="seRealizaronCambios(estudio._id)"
                v-model="estudio.estatus"
                :options="opcionStatus"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="DOCUMENTO OBTENIDO ">
              <b-form-select
                :disabled="status == 'Concluida' || estudio.tipoOperacion == 'SIN CAMBIOS'"               
                @change="seRealizaronCambios(estudio._id)"
                v-model="estudio.documentoObtenido"
                :options="documento"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <label >FECHA DE OBTENCIÓN</label>
            <datetime
              :disabled="status == 'Concluida' || estudio.tipoOperacion == 'SIN CAMBIOS'"
              :input-class="'form-control input'"
              v-model="estudio.fechaObtencion"
              type="date"
              @change="seRealizaronCambios(estudio._id)"
              />
          </b-col>

          <!-- <b-col md="12">
            <b-row style="text-align: center">
              <b-col>
              <b-button
                v-if="status !== 'Concluida'"
                v-show="estudio.tipoOperacion === 'MODIFICAR'"
                variant="primary"
                size="sm"
                @click="guardarEscolaridad(estudio, index)"
                >GUARDAR</b-button>
                <p v-if="checarCambios(estudio, index)" class="error-text"><i>No se han guardado los cambios</i> </p>
              </b-col>
            </b-row>
          </b-col> -->
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-row>
    <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" v-show="escolaridad.length < 3"  variant="primary" size="sm" @click="mostrarAgregar=true"
          >AGREGAR ESCOLARIDAD</b-button
        >
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="curriculo.aclaracionesObservaciones"
            placeholder="ACLARACIONES / OBSERVACIONES"  
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
      <b-col>
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button >
      </b-col>
    
      <b-col >
        <b-button variant="secondary"  @click="verSeccion(2)" :disabled="enviando">Anterior</b-button>
        <b-button
          class="pull-right"
          variant="primary"
          @click="actualizarObservaciones()"
          :disabled="enviando"
          >Siguiente</b-button>
      </b-col>
    </b-row>
    <AgregarEscolaridad
      v-if="mostrarAgregar"
      :mostrar="mostrarAgregar"
      @cancelar="mostrarAgregar= false"
      @escolaridadAgregada="escolaridadAgregada"
      />
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
const { dt } = require("luxon");
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import AgregarEscolaridad  from './agregarEscolaridad.vue'
export default {
  name:"curriculo",
  components: { Loader, Datetime, AgregarEscolaridad },
  props: ["curriculo", "status"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      mostrarAgregar:false,
      enviando: false,
      cambios: false,
      cambiosEscolaridad: [],
      agregaotro: false,
      contador: 0,
      escolaridad: [{}],
   
      operacion:null,
      tipoOperacion: ["MODIFICAR", "SIN CAMBIOS", "BAJA"],
      nivel: [
        { clave: "PRI", valor: "PRIMARIA" },
        { clave: "SEC", valor: "SECUNDARIA" },
        { clave: "BCH", valor: "BACHILLERATO" },
        { clave: "CTC", valor: "CARRERA TÉCNICA O COMERCIAL" },
        { clave: "LIC", valor: "LICENCIATURA" },
        { clave: "ESP", valor: "ESPECIALIDAD" },
        { clave: "MAE", valor: "MAESTRÍA" },
        { clave: "DOC", valor: "DOCTORADO" }
      ],
      pais: [
        { clave: "MX", valor: "MÉXICO" },
        { clave: "EX", valor: "EXTRANJERO" }
      ],
      opcionStatus: ["CURSANDO", "FINALIZADO", "TRUNCO "],
      documento: ["BOLETA", "CERTIFICADO", "CONSTANCIA", "TITULO"],
 
    };
  },
  methods: {
    

    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },

    checarCambios(estudio) {
      let index = this.cambiosEscolaridad.findIndex(x => x._id == estudio._id);
      return this.cambiosEscolaridad[index].cambios;
    },
    seRealizaronCambios(id) {
      let index = this.cambiosEscolaridad.findIndex(x => x._id == id);
      this.cambiosEscolaridad[index].cambios = true;
    },
    seleccionaValor(index) {
      let indice = this.nivel.findIndex(x => x.clave == this.escolaridad[index].nivel.clave);
      this.escolaridad[index].nivel.valor = this.nivel[indice].valor;
    },
    // modificarEscolaridad(estudio, index) {
    //  this.enviando = true;
 
        
    //     axios.put(this.httpURL +"/declaraciones/V2/datosCurricularesDeclarante/" + this.$route.params.id +"/escolaridad/" + estudio._id,
    //         {
    //           nivelClave: estudio.nivel.clave,
    //           nivelValor: estudio.nivel.valor,
    //           institucionEducativaNombre: estudio.institucionEducativa.nombre,
    //           institucionEducativaUbicacion: estudio.institucionEducativa.ubicacion,
    //           carreraAreaConocimiento: estudio.carreraAreaConocimiento,
    //           estatus: estudio.estatus,
    //           documentoObtenido: estudio.documentoObtenido,
    //           fechaObtencion: estudio.fechaObtencion
    //         },
    //         { headers: { token: this.sessionToken } }
    //       )
    //       .then(res => {        
    //         if (res.data.ok) {
    //           this.$notify({ group: "foo",type: "success",duration: 2500,speed: 1000,  text: res.data.mensaje});
    //           this.cambiosEscolaridad[index].cambios = false;
    //         }
    //         this.enviando = false;
    //       })
    //       .catch(error => {
    //         this.$notify({ group: "foo", type: "error", duration: 2500, speed: 1000,text: "No se pudo guardar la sección."});
    //         this.enviando = false;         
    //       });

    // },
    actualizarObservaciones() {
      this.enviando = true;
      let ninguno = this.escolaridad.length <= 0 ? true : false
      axios
        .put(this.httpURL +"/declaraciones/V2/datosCurricularesDeclarante/" + this.$route.params.id + "/aclaracionesObservaciones",
          {
            aclaracionesObservaciones: this.curriculo.aclaracionesObservaciones,
            escolaridad:this.escolaridad,
            ninguno
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          if (res.data.ok ) {
            this.verSeccion(4)
            this.$notify({group: "foo", type: "success",duration: 2500,speed: 1000, text: res.data.mensaje});
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          //console.log(error);
          this.$notify({  group: "foo", type: "error", duration: 2500, speed: 1000,text: "No se pudo guardar la sección."    });
          this.enviando = false;
         
        });
    },
    eliminarEscolaridad(id, index) {
        swal({
          text: "¿ESTÁ SEGURO DE ELIMINAR LA ESCOLARIDAD?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            this.enviando=true;
            axios
              .delete(this.httpURL +"/declaraciones/V2/datosCurricularesDeclarante/" + this.$route.params.id +"/escolaridad/" + id,
                { headers: { token: this.sessionToken } }
              )
              .then(res => {
                if (res.data.ok) {
                  this.$notify({group: "foo", type: "success", duration: 2500, speed: 1000, text: res.data.mensaje });
                  this.escolaridad.splice(index, 1);
                  this.cambiosEscolaridad.splice(index, 1);
                  this.contador--;
                }
                this.enviando = false;
              })
              .catch(error => {
                this.$notify({group: "foo", type: "error",duration: 2500,speed: 1000,text: "No se pudo guardar la sección."});
                this.enviando = false;
               
              });
          }
        });
      
    },
    escolaridadAgregada(escolaridad){
      this.mostrarAgregar=false;
      this.escolaridad.push(escolaridad);
      let objeto = { _id: escolaridad._id, cambios: false };
      this.cambiosEscolaridad.push(objeto);
    }

  },

  created() {
   
    this.escolaridad = this.curriculo.escolaridad;
    if(this.escolaridad.length>0){
      this.escolaridad.forEach(element => {
      let objeto = { _id: element._id, cambios: false };
      this.cambiosEscolaridad.push(objeto);
      })
      
    };
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
